// Languages tab: the languages the product is available in (multi select).
import React from "react"
import DropdownSelect from "aldoo-ra/DropdownSelect"
import useProductEditorTexts from "aldoo-ra/CMSModels/StoreProduct/useProductEditorTexts"
import HelpHint from "aldoo-ra/HelpCenter/InPlaceHelp"

export default function LanguagesTab({ editor, shouldShowField, isProductEditor, languages }) {
  const { read, set } = editor
  const t = useProductEditorTexts()
  if (!shouldShowField("languages")) return null
  const options = (languages || []).map((l) => ({ value: l.code, name: l.displayName }))
  const selected = (read("languages") || []).map((code) => options.find((o) => o.value === code)).filter(Boolean)
  return (
    <div className="md:w-1/2 mt-2 mb-5" data-testid="select-languages">
      <span className="text-xs font-medium text-admin_text_secondary inline-flex items-center gap-1.5">{t`Languages`}<HelpHint helpKey="vendor.product#languages" /></span>
      <DropdownSelect
        variant="admin"
        options={options}
        value={selected}
        multiSelection
        showItemNamesInSelection
        showSelectAll={false}
        disabled={!isProductEditor}
        placeholder={t`Languages`}
        onChange={(picked) => set("languages", (Array.isArray(picked) ? picked : [picked]).filter(Boolean).map((p) => p.value))}
        styleOverrides={{ button: "min-h-[38px] inline-flex items-center justify-between w-full rounded-md border border-admin_bordered px-3 bg-admin_paper text-sm font-normal text-admin_text outline-none focus:border-admin_primary hover:bg-admin_paper transition-colors disabled:opacity-60" }}
      />
    </div>
  )
}
